module.exports = __webpack_public_path__ + "resources/img/ico_download.38af8683ce06f76f5cd69a2bcf50e665.png";